<script>
import { shippingMethodMultiProps, useShippingMethodMulti } from "./mixin";
import ShippingService from "./shipping-method-multi-service";
import Planning from "@/containers/planning";
import Button from "@/components/atoms/button";
import Card from "@/components/molecules/card";
import PointRetraitSelector from "@/components/organisms/point-retrait-selector/mobile";
import StickyFooter from "@/components/molecules/sticky-footer";
import ShippingMethodPhone from "@/containers/shipping-method/shipping-method-phone";

export default {
  name: "ShippingMethodMultiMobile",
  components: {
    Planning,
    Button,
    Card,
    PointRetraitSelector,
    StickyFooter,
    ShippingMethodPhone
  },
  props: {
    ...shippingMethodMultiProps()
  },
  setup(props) {
    const { serviceModel, serviceSelected, resetService } =
      useShippingMethodMulti(props);

    return {
      serviceModel,
      serviceSelected,
      resetService
    };
  },
  data() {
    return {
      ShippingService,
      selectedService: null,
      error: null
    };
  },
  methods: {
    chooseService(service) {
      this.selectedService = service;
    }
  }
};
</script>

<template>
  <div>
    <template v-if="!serviceModel">
      <p class="u-text-left u-color-grey-1 u-ml-sm u-pt-md u-mb-md">
        Merci de sélectionner votre point de retrait parmi ceux rattachés au magasin de {{ magasinName }}
      </p>
      <PointRetraitSelector
        :services="modeCommande.services"
        :infos-possible-services="infosPossibleServices"
        @serviceSelected="chooseService"
      />
      <StickyFooter>
        <div class="u-text-center">
          <Button
            variant="primary"
            radius="full"
            size="md"
            :disabled="selectedService === null"
            @click="serviceSelected(selectedService)"
          >
            Je valide ce point de retrait
          </Button>
        </div>
      </StickyFooter>
    </template>
    <div v-if="serviceModel">
      <Card variant="bg">
        <div class="c-shipping-address-mobile">
          <p class="c-shipping-address-mobile__title">
            <strong>Votre point de retrait</strong>
          </p>
          <div class="c-shipping-address-mobile__address">
            <p class="c-shipping-address-mobile__address-title u-text-ellipsis">
              <strong class="u-mr-xs">{{ serviceModel.description }}</strong>
              <br>
              {{ serviceModel.adresse }}
              <br>
              {{ serviceModel.details }}
            </p>
            <Button
              v-if="modeCommande.services.length > 1"
              class="c-shipping-address-mobile__button u-ml-xs"
              link
              @click="resetService()"
            >
              Changer
            </Button>
          </div>
        </div>
      </Card>

      <div>
        <ShippingMethodPhone
          v-if="eligibleAlerteSms"
          :is-lad="false"
          :error="error"
          class="u-mb-lg"
        />
        <div class="u-px-sm u-mb-md">
          <p class="u-flex u-mb-xs u-font-20 u-font-secondary">
            <strong>Créneau horaire</strong>
          </p>
          <p>
            Merci de préciser le créneau horaire auquel vous souhaitez retirer vos produits
          </p>
        </div>
        <div>
          <Planning
            :service-id="serviceModel.id"
            :infos-legales="serviceModel.info_non_retrait"
            @error="(err) => {error = err}"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/shipping-address-mobile.scss";
</style>
